<template>
    <div>
        <config-main-title>
            Brasíndice {{ versao_selecionada ? (' / ' + versao_selecionada.search) : '' }}
        </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-6">
                <az-input v-model="search">
                    <template v-slot:button-pre>
                        <div class="input-group-prepend" v-if="versao_selecionada">
                            <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="load()">
                                <i class="fas fa-sync-alt"></i>
                            </button>
                        </div>
                    </template>
                    <template v-slot:buttonposb>
                        <div class="input-group-prepend" v-if="versao_selecionada">
                            <button type="button" class="btn btn-outline-primary" @click="editar_nome_tabela()">
                                <i class="fas fa-edit"></i>
                            </button>
                        </div>
                        <importacao 
                            service="brasindices" 
                            @refresh="load_brasindice()" 
                            :parms="{ id_tabela_versao: versao_selecionada ? versao_selecionada.id_tabela_versao : null }"  
                            v-if="versao_selecionada" 
                        />
                        <importacao 
                            service="brasindices" 
                            :excluir="true"
                            @refresh="load_brasindice()" 
                            :parms="{ id_tabela_versao: versao_selecionada ? versao_selecionada.id_tabela_versao : null }"  
                            v-if="versao_selecionada" 
                        />
                    </template>
                </az-input>
            </div>

            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir ()">
                    Incluir Versão
                </button>
            </div>

            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
        </div>

        <div v-if="listaVersao && listaVersao.length && !versao_selecionada">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in listaVersao" :key="id">
                    <span>
                        <a href="#" @click.prevent="selecionar_versao(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input"
                                :id="'ativo-' + id"
                                v-model="dado.fl_ativo"
                                @change="toggle_versao(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <div v-if="(!lista || !lista.length) && versao_selecionada">
            <az-empty-state
                :msg="'Nenhum item da tabela Brasíndice Identificado.'"
                icon="fas fa-search" />
		</div>

        <div v-else-if="versao_selecionada">

            <small>{{ dados.from }} - {{ dados.to }} / {{ dados.total }}</small>
            <table class="table bg-white table-hover cabecalho-fixo">
                <thead>
                    <tr>
                        <th>Laboratório</th>
                        <th>Apresentação</th>
                        <th>Descrição</th>
                        <th>Cod. Bras</th>
                        <th>Cod. Tuss</th>
                        <th>Qtd. Emb.</th>
                        <th class="text-right text-info">PFB</th>
                        <th class="text-right text-info">PFB Frac</th>
                        <th class="text-right text-success">PMC</th>
                        <th class="text-right text-success">PMC Frac</th>
                        <th class="text-right"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, iix) in lista" :key="iix">
                        <td>{{ item.st_nome_laboratorio }}</td>
                        <td>{{ item.st_nome_apresentacao }}</td>
                        <td>{{ item.st_nome }}</td>
                        <td>{{ item.st_codigo_brasindice_tiss }}</td>
                        <td>{{ item.st_codigo_tuss }}</td>
                        <td>{{ item.in_quantidade_fracionamento }}</td>
                        <td class="text-right">{{ $util.formatMoeda(item.dc_preco_pfb) }}</td>
                        <td class="text-right">{{ $util.formatMoeda(item.dc_preco_fracionado_pfb) }}</td>
                        <td class="text-right">{{ $util.formatMoeda(item.dc_preco_pmc) }}</td>
                        <td class="text-right">{{ $util.formatMoeda(item.dc_preco_fracionado_pmc) }}</td>
                        <td class="text-right">
                            <az-audit-log-button sizing="sm" :link="true" model="brasindice" :id="item.id_brasindice" class="p-0" />
                        </td>
                    </tr>
                </tbody>
            </table>

            <br><br><br><br><br>
        </div>

        <!-- Paginação -->
        <nav class="navbar fixed-bottom navbar-light bg-light pb-3 d-flex justify-content-between">
            <paginate
                v-if="dados && dados.last_page > 1"
                class="mb-0"
                :page-count="dados.last_page"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :prev-class="'page-link'"
                :next-class="'page-link'"
                :prev-text="'<<'"
                :next-text="'>>'"
                :click-handler="paginar">
            </paginate>

            <div v-if="versao_selecionada">
                <button type="button" class="btn btn-secondary mx-2" @click="fechar()">
                    Fechar
                </button>
                <button type="button" class="btn btn-primary" @click="atualizarPrecos()">
                    Atualizar Preços
                </button>
            </div>
        </nav>

        <tabela-atualizar-precos ref="tabelaAtualizarPrecos"/>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Versão Brasinídice
                            {{ item.id_tabela_versao ? '#' + item.id_tabela_versao : 'Nova' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_nome" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="% ICMS"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.dc_icms" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                              <az-sub-title title="Fatores de conversão PF para PMC" />

                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Lista Positiva"
                                    type="number"
                                    precision="6"
                                    :validate="validate"
                                    v-model="item.dc_icms_positiva" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Lista Negativa"
                                    type="number"
                                    :precision="6"
                                    :validate="validate"
                                    v-model="item.dc_icms_negativa" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Lista Neutra"
                                    type="number"
                                    :precision="6"
                                    :validate="validate"
                                    v-model="item.dc_icms_neutra" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="incluir_versao ()">{{ item.id_tabela_versao ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <pre v-if="false">{{ dados }}</pre>
    </div>
</template>


<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
//import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Importacao from '../shared/Importacao.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import TabelaAtualizarPrecos from "../../cadastros/shared/TabelaAtualizarPrecos.vue";

export default {
    data () {
        return {
            breadcrumb: null,
            search: "",
            viewMode: 'A',
            dados: null,
            page: 1,
            versoes: [],
            versao_selecionada: null,
            item: null,
            validate: false,
        };
    },

    components: {
        ConfigMainTitle,
        Importacao,
        AzEmptyState,
        AzInput,
        TabelaAtualizarPrecos,
        AzAuditLogButton,
        AzSubmit,
        AzSubTitle
    },

    computed: {
        lista: function () {
            if ( !this.dados || !this.dados.data )
                return null;

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return (this.dados && this.dados.data && this.dados.data.length) ? 
                this.dados.data.filter (item => { 
                    return ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        listaVersao: function () {
            if ( !this.versoes )
                return null;

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return (this.versoes && this.versoes.length) ? 
                this.versoes.filter (item => { 
                    return (!this.search || reg.test(JSON.stringify(item))) &&
                        (this.viewMode == 'A' ? item.fl_ativo : true);
                }) : null;
        }
    },

    methods: {
        editar_nome_tabela () { 
            this.item = _.cloneDeep(this.versao_selecionada);
            $('#edicaoModal').modal('show');
        },

        incluir() {
            this.item = {
                st_nome: "",
                id_unidade: 1,
                st_versao: '1',
                ch_tipo_tabela: 'P',
                st_aplicacao: 'BRA',
                dc_valor_uco: 0,
                dc_valor_filme: 0,
                fl_ativo: true,
                fl_moeda_corrente: true,
                fl_tem_imagem: false,
                fl_tem_cirurgia: false,
                dc_icms: 0,
            };

            $('#edicaoModal').modal('show');
        },

        incluir_versao() {
            this.$util.atualizar(this, { 
                service: 'tabela_versaos',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });

            this.versao_selecionada = null;
            this.dados = null;
        },

        fechar() {
            this.versao_selecionada = null;
            this.dados = null;
        },

        selecionar_versao(dado) {
            this.versao_selecionada = dado;
            this.load_brasindice();
        },

        toggle_versao(dado) {
            this.$util.toggle(this, {
                service: "tabela_versaos",
                dados: dado,
            });
        },

        load_brasindice() {
            this.$util.load(this, {
                service: "brasindices",
                parms: {
                    search: this.search,
                    size: 100,
                    page: this.page,
                    id_tabela_versao: this.versao_selecionada.id_tabela_versao,
                },
                page: this.page,
                size: 100,
            });
        },

        load() {
            if (this.versao_selecionada) {
                this.load_brasindice();
            } else {
                this.$util.load(this, { 
                    service: "tabela_versaos",
                    parms: { 
                        brasindice: true,
                        cadastro: true,
                    },
                    loadTo: res => { 
                        this.versoes = res;
                    }
                });
            }
        },

        atualizarPrecos() {
            this.$refs.tabelaAtualizarPrecos.show('brasindice');
        },

        paginar (page) {
            this.page = page;
            this.load();
        },
    },

    mounted () {
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Brasíndice" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },
}
</script>
